import React from 'react';
import {useSelector} from '@xstate/react';
import {BrandButton} from '../../lib/brand-button/brand-button';
import useLabelTranslation from 'src/hooks/useLabelTranslation';
import {useBookingMachine} from '../../hooks/useBookingMachine';
import {selectError} from '../../selectors/commonSelector';
import {selectSelectedTimeSlot} from '../../selectors/booking-selector';

import {InContextAlert} from '@spaced-out/ui-design-system/lib/components/InContextAlert';

import css from './booking-reschedule.css';


export const BookingReschedule = () => {
  const {t} = useLabelTranslation();
  const {bookingActor, bookingState} = useBookingMachine();
  const selectedTimeSlot = useSelector(bookingActor, selectSelectedTimeSlot);
  const {errorMessage} = useSelector(bookingActor, (state) =>
    selectError(state, t),
  );

  const hasError = bookingState.matches({
    dateTimePicker: 'retryReschedule',
  });

  const handleRescheduleTimeSlotSelect = () => {
    bookingActor.send({type: 'timeslot.confirm'});
  };

  return (
    <div className={css.rescheduleButtonSection}>
      <BrandButton
        isFluid
        actionType="submit"
        disabled={!selectedTimeSlot}
        isLoading={bookingState.matches({
          dateTimePicker: 'rescheduleFormSubmitting',
        })}
        onClick={handleRescheduleTimeSlotSelect}
      >
        {t('Reschedule_Meeting', 'Reschedule Meeting')}
      </BrandButton>
      {hasError && (
        <InContextAlert leftIconName="shield-exclamation" semantic="danger">
          {/* already translated in errorMessage */}
          {/* eslint-disable-next-line @spaced-out/i18n/no-dynamic-labels */}
          {errorMessage}
        </InContextAlert>
      )}
    </div>
  );
};
